@if (formField(); as field) {
  <app-file-uploader
    [maxlength]="field.maxlength!"
    [accept]="field.accept"
    [minlength]="field.minlength!"
    [uploadHandler]="field.uploadHandler"
    [deleteHandler]="field.deleteHandler"
  />
}
